import React, { useEffect } from 'react';
import './AppDownload.css';
import { APP_STORE_URL, detectarPlataforma, PLAY_STORE_URL } from '@src/shared/utils/stores';

const AppDownload = () => {
    useEffect(() => {
        const plataforma = detectarPlataforma();
        if (plataforma === 'android') {
            window.location.href = PLAY_STORE_URL;
        } else if (plataforma === 'ios') {
            window.location.href = APP_STORE_URL;
        }
    }, []);

    return (
        <div className="app-download-container">
            <div className="download-info">
                <h1>Descarga Kabandu</h1>
                <p>Disponible en tu tienda de aplicaciones favorita.</p>
                <div className="store-buttons">
                    <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                            alt="Get it on Google Play"
                        />
                    </a>
                    <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                            alt="Download on the App Store"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AppDownload;
